import React from 'react';
import { connect } from 'react-redux';
import { getTextResult, textKey } from 'core/textResult'
const Footer = (props) => {
    return (
        <footer className="bg-[#55565A] opacity-90  text-white py-8 mt-4">
            <div className="container mx-auto px-4">
                <div className="flex flex-col items-start">
                    <p className="font-bold text-lg">{getTextResult(textKey.FOOTER1)}</p>
                    <p className="font-bold text-lg">{getTextResult(textKey.FOOTER2)}</p>
                    <p>{getTextResult(textKey.FOOTER3)}</p>
                    <p>{getTextResult(textKey.FOOTER4)}</p>
                    <p>{getTextResult(textKey.FOOTER5)} <a href="tel:+66020886400" className="text-yellow-400">+66 (0) 2 088 6400</a></p>
                </div>
            </div>
        </footer>
    );
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);